import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useState } from "react";
import { InsulinReminderContent } from "@madmedical/ui";
import { useMe } from "@madmedical/user";
import InsulinReminderProviders from "./InsulinReminderProviders";
import DeleteInsulinReminderModal from "./DeleteInsulinReminderModal";
import EditInsulinReminderModalForm from "./EditInsulinReminderModalForm";
export const InsulinReminderPage = () => {
    const { roles: { isPatient }, } = useMe();
    const [editReminderData, setEditReminderData] = useState();
    const [deleteReminderId, setDeleteReminderId] = useState();
    const handleDeletePress = useCallback((id) => {
        setDeleteReminderId(id);
    }, []);
    const handleDialogClose = useCallback(() => {
        setDeleteReminderId(undefined);
    }, []);
    return (_jsxs(InsulinReminderProviders, { children: [_jsx(InsulinReminderContent, { isPatient: isPatient, deleteReminder: handleDeletePress, editReminder: setEditReminderData }), _jsx(DeleteInsulinReminderModal, { id: deleteReminderId, open: !!deleteReminderId, onClose: handleDialogClose }), _jsx(EditInsulinReminderModalForm, { open: !!editReminderData, onClose: () => setEditReminderData(undefined), reminderData: editReminderData })] }));
};
